import { GeneralService } from "./GeneralService";
import { FinetuneRunNew } from "../model_gen/finetuning";

export class FinetuneRunService {
  public static getFinetuneRuns(
    offset: number = 0,
    limit: number = 10,
    loadingHandler: ((val: boolean) => void) | undefined,
    apiKey: string
  ) {
    return GeneralService.get(
      `/finetune_runs/?offset=${offset}&limit=${limit}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getFinetuneRunsByDatasetId(
    datasetId: number,
    offset: number = 0,
    limit: number = 10,
    loadingHandler: ((val: boolean) => void) | undefined,
    apiKey: string
  ) {
    return GeneralService.get(
      `/finetune_runs/dataset/${datasetId}?offset=${offset}&limit=${limit}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static createFinetuneRun(
    finetuneRun: FinetuneRunNew,
    loadingHandler: ((val: boolean) => void) | undefined,
    apiKey: string
  ) {
    return GeneralService.post(
      "/finetune_runs/",
      JSON.stringify(finetuneRun),
      loadingHandler,
      JSON,
      GeneralService.PROD_WEST_ENDPOINT,
      apiKey
    );
  }

  public static getFinetuneRunById(
    runId: number,
    loadingHandler: ((val: boolean) => void) | undefined,
    apiKey: string
  ) {
    return GeneralService.get(
      `/finetune_runs/${runId}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static deployFinetuneRun(
    runId: number,
    modelName: string,
    loadingHandler: ((val: boolean) => void) | undefined,
    apiKey: string
  ) {
    return GeneralService.post(
      `/finetune_runs/${runId}/deploy`,
      JSON.stringify({ model_name: modelName }),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static retryFinetuneRun(
    runId: number,
    loadingHandler: ((val: boolean) => void) | undefined,
    apiKey: string
  ) {
    return GeneralService.post(
      `/finetune_runs/${runId}/retry`,
      JSON.stringify({}),
      loadingHandler,
      JSON,
      GeneralService.PROD_WEST_ENDPOINT,
      apiKey
    );
  }
}
